module.exports = __webpack_public_path__ + "static/media/supporticon.1a04bda6.svg";